module.exports = __webpack_public_path__ + "img/offer2.1b2dcd3d.png";